import { Link } from "react-router-dom";
import { matches } from "@/mocks/matches";
import { teams } from "@/mocks/teams";

export default function LiveNow() {
  const liveMatches = matches.filter((m) => m.status === "live");

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-accent-600 mb-2">
              <span className="w-6 h-px bg-accent-500"></span>
              LIVE NOW
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              同时开赛的直播
            </h2>
          </div>
          <Link
            to="/category/season"
            className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap shrink-0"
          >
            查看全部赛事
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        {liveMatches.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-14 text-center text-sm text-foreground-500">
            当前无直播赛事，敬请期待
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {liveMatches.map((m) => {
              const home = teams.find((t) => t.id === m.homeTeamId);
              const away = teams.find((t) => t.id === m.awayTeamId);
              return (
                <div
                  key={m.id}
                  className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 flex flex-col"
                >
                  <div className="flex items-center justify-between gap-2 mb-4">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-semibold text-background-50">
                      <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse-live"></span>
                      直播中
                    </span>
                    <span className="text-xs text-foreground-500">
                      {m.stage} · 第 {m.minute} 分钟
                    </span>
                  </div>
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-2 flex-1 min-w-0">
                      <span className="w-9 h-9 rounded-md bg-background-100 flex items-center justify-center overflow-hidden shrink-0">
                        <img
                          src={home?.crest}
                          alt={`${home?.name}队徽`}
                          title={`${home?.name} 欧冠直播`}
                          className="w-full h-full object-contain"
                        />
                      </span>
                      <span className="text-sm font-medium text-foreground-900 truncate">
                        {home?.name}
                      </span>
                    </div>
                    <span className="font-heading text-xl font-bold text-foreground-950 shrink-0">
                      {m.homeScore} : {m.awayScore}
                    </span>
                    <div className="flex items-center gap-2 flex-1 min-w-0 justify-end">
                      <span className="text-sm font-medium text-foreground-900 truncate text-right">
                        {away?.name}
                      </span>
                      <span className="w-9 h-9 rounded-md bg-background-100 flex items-center justify-center overflow-hidden shrink-0">
                        <img
                          src={away?.crest}
                          alt={`${away?.name}队徽`}
                          title={`${away?.name} 欧冠直播`}
                          className="w-full h-full object-contain"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between">
                    <span className="text-xs text-foreground-500 truncate">{m.venue}</span>
                    <Link
                      to={`/live/${m.id}`}
                      className="inline-flex items-center gap-1 text-xs font-semibold text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
                    >
                      <i className="ri-live-line" aria-hidden="true"></i>
                      进入直播
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}